module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/timesheet/Row.ejs -->\n';
 model.getTimeEntryItems().forEach(function (item) { 
__p+='\n<tr>\n    <td>\n        ';
 if (!item) { 
__p+='\n            '+
((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
'\n        ';
 } else { 
__p+='\n            '+
((__t=( item.get('name') ))==null?'':_.escape(__t))+
'\n            <a class="fa fa-times btn-delete js-destroy m-l-sm"\n                data-entry-item-id="'+
((__t=( item.id ))==null?'':_.escape(__t))+
'"\n                tabindex="-1"></a>\n        ';
 } 
__p+='\n    </td>\n    ';
 rowEntry = null; 
__p+='\n    ';
 dates.forEach(function (date) { 
__p+='\n        ';
 entry = model.getTimeEntry(date.toDate(), item) 
__p+='\n        <td class="form-group">\n            ';
 if (entry) { 
__p+='\n                ';
 rowEntry = entry 
__p+='\n            <input type="text" name="hours-'+
((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
'"\n                data-entry-date="'+
((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
'"\n                data-entry-item="'+
((__t=( entry.get('payrollItemId') ))==null?'':_.escape(__t))+
'"\n                class="form-control form-control-invisible js-hours"\n                value="'+
((__t=( parseFloat((entry.get('hours') || 0).toFixed(2)) ))==null?'':_.escape(__t))+
'"\n                data-value-type="float">\n            ';
 } 
__p+='\n        </td>\n    ';
 }) 
__p+='\n    <td class="total">\n        <input type="text" name="weekly-regular-total-'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="form-control form-control-invisible js-weekly-row-total"\n            ';
 if (rowEntry) { 
__p+='\n                data-entry-item="'+
((__t=( rowEntry.get('payrollItemId') ))==null?'':_.escape(__t))+
'"\n            ';
 } 
__p+='\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n    <td class="total">\n        <input type="text" name="monthly-regular-total-'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="form-control form-control-invisible js-monthly-row-total"\n            ';
 if (rowEntry) { 
__p+='\n                data-entry-item="'+
((__t=( rowEntry.get('payrollItemId') ))==null?'':_.escape(__t))+
'"\n            ';
 } 
__p+='\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n</tr>\n';
 }) 
__p+='\n<tr class="js-totals">\n    <td>\n        <strong>Totals</strong>\n    </td>\n    ';
 dates.forEach(function (date) { 
__p+='\n        <td class="form-group">\n            <input type="text" name="daily-hours-'+
((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
'"\n                class="form-control form-control-invisible js-daily-total"\n                data-entry-date="'+
((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
'"\n                value="'+
((__t=( model.getTimeEntriesDailyTotal(date.toDate()) ))==null?'':_.escape(__t))+
'"\n                readonly tabindex="-1"\n                data-value-type="float">\n        </td>\n    ';
 }) 
__p+='\n    <td class="total">\n        <input type="text" name="weekly-total-'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="form-control form-control-invisible js-weekly-total"\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n    <td class="total">\n        <input type="text" name="monthly-total-'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="form-control form-control-invisible js-monthly-total"\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n        </td>\n</tr>\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/timesheet/Row.ejs
// module id = 1031
// module chunks = 1